module.exports = "/_next/static/images/fae6f285ea425e11b7fdcf56833be488-roxinho-scene-card-with-phone-md@3x.jpg";